/** pt-BR labels for Segurança and the trip detail (trip_alerts, trip_shares). */

/** trip_alerts kinds: the deviation is the safety alert; the others are automatic texts that already went out. */
export const ALERT_KIND: Record<string, { label: string; tone: string }> = {
  deviation: { label: "Desvio de rota", tone: "tone-warn" },
  auto_share: { label: "Compartilhou automaticamente", tone: "tone-info" },
  arrival: { label: "Avisou a chegada", tone: "tone-ok" },
  recipient: { label: "Avisou quem recebe", tone: "tone-neutral" },
};

/** One line about what the automatic rule did ("à noite", "2 contatos", …). */
export function alertDetail(kind: string, data: Record<string, unknown>) {
  if (kind === "deviation") return "Saiu da rota prevista · o passageiro e os contatos de confiança foram avisados";
  if (kind === "auto_share") return data.reason === "night" ? "Regra “à noite” do passageiro" : "Regra “em toda viagem” do passageiro";
  if (kind === "arrival") return typeof data.contacts === "number" ? `${data.contacts} ${data.contacts === 1 ? "contato avisado" : "contatos avisados"}` : "Contatos avisados";
  if (kind === "recipient") return "SMS com o link e o código de entrega";
  return "";
}

type Share = { by: "rider" | "driver" | "recipient"; contacts: number; active: boolean; source: string };
export function shareText(s: Share) {
  const who = s.by === "rider" ? "Passageiro" : s.by === "driver" ? "Motorista" : "Quem recebe";
  const contacts = s.by === "recipient" ? "" : ` · ${s.contacts} ${s.contacts === 1 ? "contato" : "contatos"}`;
  return `${who}${s.source === "auto" ? " (automático)" : ""}${contacts} · ${s.active ? "link ativo" : "encerrado"}`;
}

// ── Ocorrências (SOS and incident reports) ───────────────────────────────────────────────

export const INCIDENT_KIND: Record<string, { label: string; tone: string }> = {
  sos: { label: "SOS", tone: "tone-bad" },
  report: { label: "Relato", tone: "tone-info" },
};

export const INCIDENT_STATUS: Record<string, { label: string; tone: string }> = {
  open: { label: "Aberta", tone: "tone-bad" },
  acknowledged: { label: "Em atendimento", tone: "tone-warn" },
  resolved: { label: "Encerrada", tone: "tone-ok" },
};

/** SAFETY_INCIDENT_CATEGORIES in the contracts. */
export const INCIDENT_CATEGORY: Record<string, string> = {
  assedio: "Assédio",
  direcao_perigosa: "Direção perigosa",
  agressao: "Agressão",
  roubo: "Roubo ou furto",
  acidente: "Acidente",
  veiculo_diferente: "Veículo ou motorista diferente",
  outro: "Outro",
};

export const reporterLabel = (role: "rider" | "driver") => (role === "driver" ? "Motorista" : "Passageiro");

/** "SOS do passageiro · IC-10023". */
export function incidentTitle(i: { kind: string; reporterRole: "rider" | "driver"; tripCode: string | null }) {
  const who = i.reporterRole === "driver" ? "do motorista" : "do passageiro";
  return `${i.kind === "sos" ? "SOS" : "Relato"} ${who}${i.tripCode ? ` · ${i.tripCode}` : ""}`;
}
